<div class="clearfix" *ngIf="!isLoading && !isPhoneVerified && isFromProfile">
    <button class="btn close-btn float-end d-block " (click)="closeVerification()"><i class="fa fa-xmark fs-xl"></i></button>
</div>  
<h4 class="text-center">Phone Number Verification</h4>
<div *ngIf="isOTPSent">
    <div class="mt-4 col-lg-5 col-md-12 mx-auto">
        <div *ngIf="!isLoading && !isPhoneVerified" class="px-4">
            <p>We've sent a code to the phone number you entered.</p>
            <p>The code is valid for 5 minutes.</p>
            <p>Please enter that number in the field below for verification.</p>
        </div>
        <div *ngIf="!isLoading && !isPhoneVerified">
            <label for="otp" class="fw-semibold">Enter Code</label>
            <input
                placeholder="XXXXXX"
                maxlength="6"
                id="otp"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                class="form-control fw-semibold text-center form-input-height"
                required
                [(ngModel)]="optCode"
                (input)="onOTPInput($event)" />
            <span *ngIf="errorText" class="text-danger">{{errorText}}</span>
            <button class="btn submit-btn bold mt-3 px-5 d-block mx-auto" (click)="verifyOTP()" [disabled]="optCode.trim().length < 6">Ok</button>
            <p style="text-align: center;" class="mt-2">Didn't receive a code? <button class="link-text" (click)="sendOTP(true)">Resend Code</button></p>
        </div>
    </div>
</div>
<div *ngIf="isLoading">
    <p class="text-center" *ngIf="isPhoneVerified">Success. Thank you for completing your phone number verification.</p>
    <p class="text-center mt-2" *ngIf="isPhoneVerified">{{isFromProfile?'Returning to your profile information...':'Redirecting to the next step...'}}</p>
    <p class="text-center" *ngIf="isOTPSent && !isPhoneVerified">Verifying...</p>
    <p class="text-center" *ngIf="!isOTPSent && !isPhoneVerified">Sending OTP...</p>
    <div class="vb-spinner-box vb-spinner-box--inline">
        <vb-spinner size="sm"></vb-spinner>
    </div>
</div>
<div *ngIf="!isPhoneVerified && !isOTPSent && !isLoading">
    <div class="mt-4 col-lg-5 col-md-12 mx-auto">
        <div class="px-4">
            <p>Before we log you in, we need to verify your phone number for security, we'll send you a text message with a code.</p>
        <p>You can update your notification preferences in your profile at any time.</p>
        <p>Click Ok to receive the code.</p>
        </div>
        <button class="btn submit-btn bold mt-2 px-5 d-block mx-auto" (click)="sendOTP()">Ok</button>
        <div class="w-350 m-auto d-flex mt-2" *ngIf="!isFromProfile">
            <button
                (click)="skipTelephoneVerification()"
                class="link-text mx-auto align-self-center">
                Skip For Now
            </button>
        </div>
    </div>
</div>